import Box from "@mui/material/Box";
import { FC } from "react";
import { items } from "./constants";
import { useWorkspaceStore } from "../../store/workspace/WorkspaceStore";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { useNavigate, useLocation } from "react-router-dom";
import { appBarNavItemSelected } from "../../styles/mui/tokens/colors";

const buildWorkspaceRoute = (workspaceId: string, route: string) => {
  let path = `/projects/${workspaceId}`;

  if (route.length > 0) {
    path = `${path}/${route}`;
  }

  return path;
};

const isCurrentRoute = (
  route: string,
  workspaceId: string,
  location: ReturnType<typeof useLocation>
) => {
  const currentPath = location.pathname;

  // For exact match (workspace root)
  if (route === "") {
    const expectedPath = buildWorkspaceRoute(workspaceId, route);

    return currentPath === expectedPath;
  }

  return currentPath.includes(`/${route}`);
};

export const Sidebar: FC = () => {
  const workspace = useWorkspaceStore((state) => state.draft);
  const navigate = useNavigate();
  const location = useLocation();

  if (!workspace?.id) {
    return null;
  }

  return (
    <Stack
      width={75}
      paddingY={5}
      flexDirection="column"
      position="relative"
      flexShrink={0}
      sx={{
        borderRight: "2px solid #f3f6f7",
      }}
    >
      <List id="sidebar-list" disablePadding>
        {items.map((item) => {
          const isSelected = isCurrentRoute(item.route, workspace.id, location);
          const IconComponent = isSelected ? item.iconSelected : item.icon;
          const itemId = item.text.toLowerCase().replace(/\s+/g, "-");

          return (
            <ListItemButton
              key={item.route}
              onClick={() =>
                navigate(buildWorkspaceRoute(workspace.id, item.route))
              }
              id={itemId}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                height: "70px",
              }}
            >
              {/* Active item indicator */}
              {isSelected && (
                <Box
                  position="absolute"
                  right={0}
                  top="50%"
                  width="2px"
                  height="70px"
                  bgcolor={appBarNavItemSelected}
                  sx={{ transform: "translateY(-50%)" }}
                />
              )}
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                marginBottom="2px"
                height={35}
                width={35}
              >
                <IconComponent
                  sx={{
                    color: isSelected ? appBarNavItemSelected : "#757575",
                    fontSize: 30,
                  }}
                />
              </Stack>

              <Typography
                variant="caption"
                color={isSelected ? appBarNavItemSelected : "textSecondary"}
                align="center"
                fontSize={10}
                sx={{
                  wordWrap: "break-word",
                  letterSpacing: "0.17px",
                  lineHeight: "12px",
                }}
              >
                {item.text}
              </Typography>
            </ListItemButton>
          );
        })}
      </List>
    </Stack>
  );
};
